import { createContext, useState, useCallback } from 'react';

export const AlertContext = createContext();

export function AlertProvider({ children }) {
    const [alert, setAlert] = useState(null);

    const showAlert = useCallback((message, type = 'info', duration = 1000) => {
        setAlert({ message, type });
        
        if (duration) {
            setTimeout(() => {
                setAlert(null);
            }, duration);
        }
    }, []);

    const closeAlert = useCallback(() => {
        setAlert(null);
    }, []);

    const value = {
        alert,
        showAlert,
        closeAlert,
    };

    return (
        <AlertContext.Provider value={value}>
            {children}
        </AlertContext.Provider>
    );
}
